import React from "react";
import { connect } from "react-redux";
import { Loading } from "../../Loader";
import "../styles.css";
import Empty from "../../Empty";
import language from "../../../language";
import { CardHeader } from "../../Header";
import { Line } from "react-chartjs-2";
import icons from "../../../constants/icons";
import moment from "moment";
import { fetchTransactionsSummary } from "../../../queries/reports/transactionsQuery";
import reportFilters from "../../../queries/reports/reportFilters";

const options = {
  maintainAspectRatio: false,
  animation: false,
  offset: true,
};

class Weekly extends React.Component {
  state = {
    isLoading: false,
    data: {},
  };

  componentDidMount() {
    this.getData(true);
  }

  componentDidUpdate(prevProps) {
    if (this.props.filters !== prevProps.filters) {
      this.getData(true);
    }
  }

  getData = async (isLoading) => {
    const { defaultLanguage, filters } = this.props;
    try {
      this.setState({ isLoading });
      const responseData = await fetchTransactionsSummary(
        defaultLanguage,
        await reportFilters(filters)
      );
      const chartData = await this.returnChartData(responseData.content);
      this.setState({
        data: chartData,
        isLoading: false,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
      });
    }
  };

  defaultWeekdays = Array.apply(null, Array(7)).map(function (_, i) {
    return moment(i, "e")
      .startOf("week")
      .isoWeekday(i + 1)
      .format("ddd");
  });

  returnChartData(data) {
    let labels = {},
      chartData = [];

    data.forEach((item) => {
      const date = new Date(item.date);
      const dayOfWeek = date.getDay();

      if (!chartData[dayOfWeek]) {
        chartData[dayOfWeek] = 0;
      }

      chartData[dayOfWeek] += Math.round(item.amount);
    });

    labels = Object.keys(chartData).map((date) => {
      return moment(date).format("dddd", "yyyy");
    });

    return {
      labels: labels,
      datasets: [
        {
          label: "Transactions per Day of the Week",
          data: Object.values(chartData),
          backgroundColor: "#ffeded",
          borderColor: "#c21510",
          radius: 5,
        },
      ],
    };
  }

  render() {
    return (
      <div className="chart-container mb-3 mt-3">
        <div className="card">
          <div className="card-header">
            <div style={{ flex: 1 }}>
              <CardHeader title="Transactions per day of the week" />
            </div>
          </div>
          <div className="card-body" style={{ height: 380 }}>
            {this.state.isLoading ? (
              <Loading />
            ) : this.state.data?.datasets?.length > 0 ? (
              <Line data={this.state.data} options={options} />
            ) : (
              <Empty
                title={language[this.props.defaultLanguage].no_data}
                icon={icons.chart}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(Weekly);
